import ApiService from "../data/ApiService";
import { ENDPOINT_SPONSORS } from "../data/Configuration";

/**
 * Session service, manages CRUD operations for event session data
 * @author dame.gjorgjievski
 **/
const SponsorService = new ApiService(ENDPOINT_SPONSORS, ["name.en", "description.en", "url"])
export default SponsorService